import React from 'react';

import DeveloperModeIcon from '@material-ui/icons/DeveloperMode';

import {
  PERMISSAO_TELA_ETIQUETAS_GONDOLA_LISTAR,
  PERMISSAO_TELA_CONFERENCIA_TEMPERATURA_FREEZERS_LISTAR,
  PERMISSAO_TELA_CARTAZES_OFERTA_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuColetor = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Coletor"
    icon={<DeveloperModeIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_ETIQUETAS_GONDOLA_LISTAR] &&
      hasResource('solicitacoes_impressoes_etiqueta_2')}
    {permissoes[PERMISSAO_TELA_CARTAZES_OFERTA_LISTAR] &&
      hasResource('cartazes_oferta')}
    {permissoes[PERMISSAO_TELA_CONFERENCIA_TEMPERATURA_FREEZERS_LISTAR] &&
      hasResource('conferencias_temperatura_freezers_2')}
  </SubMenu>
);

export default SubMenuColetor;
